// src/pages/LandingPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LandingPage.css';
import PageTitle from '../components/PageTitle';

const LandingPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);   // 👈 NEW
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { currentUser, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      const isPasswordChanged = currentUser.password_changed === true || currentUser.password_changed === 'true';

      if (!isPasswordChanged && currentUser.role !== 'superuser') {
        navigate('/change-password');
      } else if (currentUser.role === 'superuser') {
        navigate('/superuser-dashboard');
      } else if (currentUser.role === 'admin') {
        navigate('/admin-dashboard');
      } else if (currentUser.role === 'teacher') {
        navigate('/teacher-dashboard');
      } else {
        navigate('/home');
      }
    }
  }, [currentUser, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      const message =
        err?.response?.data?.error ||
        (err?.response?.status === 401 && 'Invalid email or password') ||
        'Login failed. Please try again.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-wrapper">
      <PageTitle title="Staff Sign In" noIndex canonical="https://markazsync.com/" />
      <div className="landing-shell">
        <div className="form-panel">
          <div className="form-header">
            <div className="login-brand-logo-crop" aria-label="MarkazSync">
              <img className="login-brand-logo" src="/logo.png" alt="" aria-hidden="true" />
            </div>
            <p className="form-subtitle">Welcome To MarkazSync</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            <div className="floating-field">
              <input
                id="login-email"
                type="email"
                placeholder="example@gmail.com"
                value={email}
                required
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
              />
              <label className="sr-only" htmlFor="login-email">Email address</label>
            </div>

            <div className="password-field floating-field">
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <label className="sr-only" htmlFor="login-password">Password</label>
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword((s) => !s)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                aria-pressed={showPassword}
              >
                <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true" />
              </button>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>

            <div className="forgot-password">
              <Link to="/forgot-password">Forgot password?</Link>
            </div>

          </form>

          <div className="footer-note">
            <span>© {new Date().getFullYear()} MarkazSync. All rights reserved.</span>
            <span className="login-legal-links">
              <Link to="/home">About</Link>
              <span aria-hidden="true">|</span>
              <Link to="/privacy">Privacy</Link>
              <span aria-hidden="true">|</span>
              <Link to="/terms">Terms</Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
